import { ElInput, ElSelect, ElOption } from "element-plus";
import API from "@/api/api.js";
import utils from "@/utils/utils";
export default {
  components: {
    ElInput,
    ElSelect,
    ElOption
  },
  data() {
    return {
      loading: false,
      // 按钮loading
      name: "",
      nameErrMsg: "",
      companyName: "",
      companyNameErrMsg: "",
      email: "",
      emailErrMsg: "",
      estimatedAd: "",
      estimatedAdErrMsg: "",
      adCompaign: "",
      adCompaignErrMsg: "",
      addRequest: "",
      adCompaignOptions: [{
        label: "App_Downloads",
        value: "App Downloads"
      }, {
        label: "Website_Visits",
        value: "Website Visits"
      }, {
        label: "E-commerce_Sales",
        value: "E-commerce Sales"
      }, {
        label: "Brand_Exposure",
        value: "Brand Exposure(Sponsorship)"
      }, {
        label: "Other",
        value: "Other"
      }],
      showAlert: 0 // 0: 隐藏， 1： success， 2：fail
    };
  },

  methods: {
    checkRequired(field) {
      if (!this[field]) {
        this[field + "ErrMsg"] = this.$t("required_info");
        return false;
      }
      this[field + "ErrMsg"] = "";
      return true;
    },
    checkEmail() {
      if (!this.email) {
        this.emailErrMsg = this.$t("required_info");
        return false;
      }
      if (!utils.emailPattern(this.email)) {
        this.emailErrMsg = this.$i18n.t("email_unvalid");
        return false;
      }
      this.emailErrMsg = "";
      return true;
    },
    checkValid() {
      // check name
      let nameValid = this.checkRequired("name");
      if (!nameValid) return false;
      // check companyName
      let companyNameValid = this.checkRequired("companyName");
      if (!companyNameValid) return false;
      // check email
      let emailValid = this.checkEmail();
      if (!emailValid) return false;
      // check estimatedAd
      let estimatedAdValid = this.checkRequired("estimatedAd");
      if (!estimatedAdValid) return false;
      // check adCompaign
      let adCompaignValid = this.checkRequired("adCompaign");
      if (!adCompaignValid) return false;
      return true;
    },
    handleSubmit() {
      if (this.loading) return;
      let valid = this.checkValid();
      if (valid) {
        this.loading = true;
        let params = {
          name: this.name,
          cname: this.companyName,
          address: this.email,
          money: this.estimatedAd,
          type: this.adCompaign,
          request: this.addRequest
        };
        API("linkr/sns/pub/questionnaire", params, true, true).then(data => {
          this.loading = false;
          if (data.code == 0) {
            this.handleShowAlert(1);
          } else {
            this.handleShowAlert(2);
          }
        });
      }
    },
    handleShowAlert(type) {
      this.showAlert = type;
      setTimeout(() => {
        this.showAlert = 0;
      }, 5000);
    }
  }
};